



























import { Vue, Component, Prop, Emit, Model, Watch, Ref } from 'vue-property-decorator';

@Component({
  name: 'BaseSelectList',
})
export default class BaseSelectList extends Vue {
  @Prop() items: any[];
  @Prop() highlightActive: boolean;
  @Prop() show: boolean;
  @Prop() focused: number;
  @Prop() itemLabel: string;
  @Prop() itemKey?: string;
  @Prop({ required: true }) emptyStateText!: string;

  @Ref('dropdown-list') dropdownListElement: HTMLElement;
  @Model('change') value!: any;

  itemActive(item: any): boolean {
    if (this.itemKey) {
      return this.value[this.itemKey] === item[this.itemKey];
    }
    return this.value === item;
  }

  itemFocus(index: number): boolean {
    return this.focused === index;
  }

  formattedValue(item: any): string {
    return this.itemLabel ? item?.[this.itemLabel] : item;
  }

  @Watch('focused')
  watchFocused() {
    const item: HTMLElement = document.getElementById(
      this.items?.length && this.formattedValue(this.items[this.focused])
    );
    if (item) {
      item.scrollIntoView({ block: 'nearest' });
    }
  }

  @Watch('show')
  watchValue() {
    const item: HTMLElement = document.getElementById(
      this.items?.length && this.formattedValue(this.value)
    );
    const scrollMargin = 8;
    if (item) {
      this.dropdownListElement.scrollTo({ top: item.offsetTop - scrollMargin });
    }
  }

  @Emit('change')
  handleClick(item: any): any {
    return item;
  }
}
